<template>
  <div class="w-full">
    <Inplace>
      <template #display>
        {{ child.name }}
      </template>
      <template #content="{ closeCallback }">
        <span class="inline-flex items-center gap-2">
          <InputText
            v-model="child.name"
            placeholder="Child Name"
            class="w-full mb-2"
            @input="
              (event) => {
                const eventObj = event as unknown as Record<string, Record<string, any>>

                eventObj &&
                  eventObj.target &&
                  eventObj.target.value &&
                  updateName(eventObj.target.value)
              }
            "
            fluid
          />
          <Button icon="pi pi-times" text severity="danger" @click="closeCallback" />
        </span>
      </template>
    </Inplace>

    <div class="grid grid-cols-[50px_1fr_50px_50px] gap-2 items-center">
      <Button
        size="small"
        icon="pi pi-minus"
        pt:root="!m-2 !rounded-full !h-8 !w-8"
        @click="() => onTimeImpact(child, false)"
      />
      <ProgressBar
        :value="screenTimePercentage.percentage"
        pt:label="overflow-auto"
        pt:root="!h-7 !rounded-full"
        :pt:value:class="{
          '!bg-primary-500': screenTimePercentage.isPositive,
          '!bg-red-300': !screenTimePercentage.isPositive,
        }"
        @click="() => onOpenSummary(child)"
      >
        {{ screenTimeLabel }}
      </ProgressBar>
      <Button
        size="small"
        icon="pi pi-plus"
        pt:root="!m-2 !rounded-full !h-8 !w-8"
        @click="() => onTimeImpact(child, true)"
      />
      <!--show history -->
      <Button
        size="small"
        icon="pi pi-calendar"
        pt:root="!m-2 !rounded-full !h-8 !w-8"
        @click="() => onOpenHistory(child)"
      />
    </div>

    <ImpactDrawer
      v-if="impactChild && showImpact"
      :child="impactChild as Child | null"
      :increase="impactIncrease"
      :screenTime="screenTime"
      v-model:visible="showImpact"
    />
    <ImpactHistoryDrawer
      v-if="historyChild && showHistory"
      :child="historyChild as Child | null"
      v-model:visible="showHistory"
    />

    <DaySummaryDrawer
      v-if="summaryChild && showSummary"
      :child="summaryChild as Child | null"
      v-model:visible="showSummary"
    />
  </div>
</template>

<script setup lang="ts">
  import { Model } from 'pinia-orm'
  import InputText from 'primevue/inputtext'
  import ProgressBar from 'primevue/progressbar'
  import Timeline from 'primevue/timeline'
  import { ref } from 'vue'
  import Child from '../store/models/Child'

  import { useRepo } from 'pinia-orm'
  import Button from 'primevue/button'
  import Inplace from 'primevue/inplace'
  import { useScreenTime } from './composables/useScreenTime'
  import { useImpactReason } from './composables/useImpactReason'
  import { Drawer } from 'primevue'
  import ImpactDrawer from './ImpactDrawer.vue'
  import ImpactHistoryDrawer from './ImpactHistoryDrawer.vue'
  import DaySummaryDrawer from './DaySummaryDrawer.vue'

  const childRepo = useRepo(Child)

  const props = defineProps<{
    child: Child
  }>()

  const showImpact = ref(false)
  const impactChild = ref<Child | null>(null)
  const impactIncrease = ref(false)
  const historyChild = ref<Child | null>(null)
  const showHistory = ref(false)
  const summaryChild = ref<Child | null>(null)
  const showSummary = ref(false)

  const { screenTime, screenTimePercentage, screenTimeLabel } = useScreenTime(props.child)

  const updateName = (name: string) => {
    if (props.child.id && name) {
      childRepo.save({
        id: props.child.id,
        name,
      })
    }
  }

  const onTimeImpact = (selectedChild: Child, increase: boolean) => {
    impactChild.value = selectedChild
    impactIncrease.value = increase
    showImpact.value = true
  }

  const onOpenHistory = (selectedChild: Child) => {
    historyChild.value = selectedChild
    showHistory.value = true
  }

  const onOpenSummary = (selectedChild: Child) => {
    summaryChild.value = selectedChild
    showSummary.value = true
  }
</script>
